import { Lock } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

export function AccessDenied() {
  return (
    <div className="flex items-start justify-center h-full min-h-[400px] p-6">
      <Alert variant="destructive" className="max-w-lg">
        <Lock className="h-4 w-4" />
        <AlertDescription>
          You do not have permission to view this page. Please contact your administrator.
        </AlertDescription>
      </Alert>
    </div>
  );
}
